"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.form.basicInfo': 'Basic Information',
    'tutorial.form.name': 'Training Name',
    'tutorial.form.namePlaceholder': 'Enter training name...',
    'tutorial.form.avatar': 'Leading Avatar',
    'tutorial.form.selectAvatar': 'Select Avatar...',
    'tutorial.form.company': 'Company / Assignment',
    'tutorial.form.selectCompany': 'Select Company...',
    'tutorial.form.description': 'General Description',
    'tutorial.form.descriptionPlaceholder': 'Describe briefly what this training covers...',
    'tutorial.form.introText': 'Introduction for Participant',
    'tutorial.form.introTextPlaceholder': 'Write an introduction text that welcomes the participant...',
    'tutorial.form.active': 'Active',
    'tutorial.form.steps': 'Training Steps',
    'tutorial.form.step': 'Step',
    'tutorial.form.addStep': 'Add Step',
    'tutorial.form.stepName': 'Step Name',
    'tutorial.form.stepNamePlaceholder': 'Enter step name',
    'tutorial.form.stepDescription': 'Step Description',
    'tutorial.form.stepDescriptionPlaceholder': 'Enter step description (optional)',
    'tutorial.form.selectStep': 'Select Step...',
    'tutorial.form.sections': 'Sections',
    'tutorial.form.section': 'Section',
    'tutorial.form.sectionName': 'Section Name',
    'tutorial.form.sectionNamePlaceholder': 'Enter section name...',
    'tutorial.form.sectionIntro': 'Section Introduction',
    'tutorial.form.sectionIntroPlaceholder': 'Describe what the participant will learn in this section...',
    'tutorial.form.sectionPrompt': 'Prompt (Knowledge for Section)',
    'tutorial.form.sectionPromptPlaceholder': 'Provide knowledge or guidance for this section...',
    'tutorial.form.addKnowledge': 'Add Knowledge',
    'tutorial.form.selectedKnowledge': 'Selected Knowledge',
    'tutorial.form.files': 'Screenshot / Screen',
    'tutorial.form.screenshot': 'Screenshot / Screen',
    'tutorial.form.screenshotPlaceholder': 'Select screenshot file...',
    'tutorial.form.video': 'Video (MP4)',
    'tutorial.form.videoPlaceholder': 'Select video file...',
    'tutorial.form.screenshotMini': 'Screenshot miniature',
    'tutorial.form.screenshotMiniPlaceholder': 'Select screenshot miniature...',
    'tutorial.form.attachments': 'Attachments',
    'tutorial.form.addFile': 'Add file',
    'tutorial.form.sectionFileMiniature': 'Thumbnail image',
    'tutorial.form.sectionFileRequired': 'Select a file before adding it.',
    'tutorial.form.videoMini': 'Video miniature',
    'tutorial.form.videoMiniPlaceholder': 'Select video miniature...',
    'tutorial.form.addSection': 'Add Section',
    'tutorial.form.source.label': 'Source',
    'tutorial.form.source.ai': 'AI Generated',
    'tutorial.form.source.file': 'Scan source file and generate tutorial',
    'tutorial.form.sourceFile.label': 'Source File',
    'tutorial.form.sourceFile.placeholder': 'Select source file...',
    'tutorial.form.scanPages.label': 'Index / table of contents page range',
    'tutorial.form.scanSourceFile': 'Scan source file and fill the tutorial form',
    'tutorial.form.regenerateFromPdf': 'Regenerate from source file',
    'tutorial.form.regenerateFromPdf.title': 'Regenerate tutorial from source file',
    'tutorial.form.regenerateFromPdf.confirm': 'This will regenerate the tutorial content from the source file and may replace existing content. Continue?',
    'tutorial.form.tutorialGoal': 'Tutorial Goal',
    'tutorial.form.tutorialGoalPlaceholder': 'Describe what the participant should be able to do after completing this tutorial...',
    'tutorial.form.examplePrompts_1': 'Create a beginner tutorial teaching the basics of skiing, with steps, sections and todo items',
    'tutorial.form.examplePrompts_2': 'Rewrite the description and intro text so they match the tutorial goal',
    'tutorial.form.examplePrompts_3': 'Add a short todo checklist to every section of this tutorial',
    'tutorial.form.scanNeedsData': 'Fill in at least the name, goal or description (or add steps) so AI has something to expand on',
    'tutorial.form.start.title': 'How do you want to start?',
    'tutorial.form.start.onboarding.title': 'AI Course Creator',
    'tutorial.form.start.onboarding.description': 'Answer a short guided questionnaire about your course. AI will shape the tutorial around your answers.',
    'tutorial.form.start.onboarding.action': 'Start guided questionnaire',
    'tutorial.form.start.form.title': 'Blank tutorial',
    'tutorial.form.start.form.description': 'Fill in the form yourself, scan a source file or ask the AI assistant for help. You can add onboarding later from the form header.',
    'tutorial.form.start.form.action': 'Open tutorial form',
    'tutorial.form.start.form.how.title': 'How it works',
    'tutorial.form.start.form.how.step1': 'Name the tutorial, choose a category, and add a description and logo.',
    'tutorial.form.start.form.how.step1.title': 'Set up the tutorial',
    'tutorial.form.start.form.how.step2': 'Create steps and sections, then arrange them in the order participants will follow.',
    'tutorial.form.start.form.how.step2.title': 'Build the structure',
    'tutorial.form.start.form.how.step3': 'Add section content and attachments such as files, images, and video.',
    'tutorial.form.start.form.how.step3.title': 'Add learning materials',
    'tutorial.form.start.form.how.step4': 'Add tasks for participants to check off as they learn.',
    'tutorial.form.start.form.how.step4.title': 'Add tasks',
    'tutorial.form.start.how.title': 'How it works',
    'tutorial.form.start.how.step1': 'You go through a short step-by-step questionnaire: course basics, audience, structure and duration, teaching style, materials, learning model and certification.',
    'tutorial.form.start.how.step1.title': 'Answer a few questions',
    'tutorial.form.start.how.step2': 'Your answers are attached to the tutorial and saved together with it.',
    'tutorial.form.start.how.step2.title': 'Keep your answers with the tutorial',
    'tutorial.form.start.how.step3': 'AI uses them as instructions whenever it generates content - in the AI assistant and when scanning a source file - so the structure, depth, tone and exercises match your choices.',
    'tutorial.form.start.how.step3.title': 'Get content tailored to your choices',
    'tutorial.form.assistant': 'Assistant',
    'tutorial.scanned': 'Tutorial scanned and form filled in successfully',
    'tutorial.scanFailed': 'Failed to scan the tutorial',
    'tutorial.category.loadFailed': 'Failed to load categories',
    'tutorial.form.expireAt': 'Expiration Date',
    'tutorial.form.scanKnowledge.label': 'Or use a knowledge entry as the scan source',
    'tutorial.form.scanKnowledge.none': 'No knowledge entry selected',
    'tutorial.form.source.ai.description': 'Tutorial content will be generated by AI in real time.',
    'tutorial.form.source.file.description': 'Upload a source file (e.g. PDF). Its table of contents is scanned to build the tutorial.',
    'tutorial.form.scanSourceFile.description.ai': 'AI will analyze the data you already entered and complete the missing tutorial structure (sections and steps).',
    'tutorial.form.scanSourceFile.description.file': 'The source file will be scanned to generate the full tutorial structure and its content (sections, steps and texts).',
    'tutorial.form.onboardingAttached': 'Onboarding attached',
    'tutorial.form.scanProgress.step': 'Step',
    'tutorial.form.scanProgress.section': 'Section',
    'tutorial.form.scanProgress.reading': 'Reading source file...',
    'tutorial.form.scanProgress.index': 'Analyzing structure and planning sections...',
    'tutorial.form.scanProgress.content': 'Writing section content',
    'tutorial.form.scanProgress.todos': 'Creating tasks',
    'tutorial.form.source_pages': 'Section source pages',
    'tutorial.form.category': 'Category',
    'tutorial.form.no_cat': 'No category',
    'tutorial.form.logo': 'Tutorial Logo',
    'tutorial.form.todoItems': 'Todo Items',
    'tutorial.form.todoItemPlaceholder': 'Enter todo item...',
    'tutorial.form.todoDescription': 'Manage todo list for this tutorial',
    'tutorial.form.addTodoItem': 'Add Todo',
    'tutorial.form.removeTodoItem': 'Remove Todo',
    'tutorial.form.noTodoItems': 'No todo items for this tutorial',
    'tutorial.form.updatedFromAI': 'Form updated from AI assistant',
    // Onboarding wizard
    'tutorial.form.onboarding.button': 'Onboarding',
    'tutorial.form.onboarding.submit': 'Generate course',
    'tutorial.form.onboarding.stepLabel': 'Step',
    'tutorial.form.onboarding.step1': 'Basic information',
    'tutorial.form.onboarding.step2': 'Audience',
    'tutorial.form.onboarding.step3': 'Course parameters',
    'tutorial.form.onboarding.step4': 'Course style',
    'tutorial.form.onboarding.step5': 'Materials to generate',
    'tutorial.form.onboarding.step6': 'Multimedia',
    'tutorial.form.onboarding.step7': 'Learning model',
    'tutorial.form.onboarding.step8': 'Certification',
    'tutorial.form.onboarding.name': 'Course name',
    'tutorial.form.onboarding.category': 'Category',
    'tutorial.form.onboarding.goals': 'Course goal',
    'tutorial.form.onboarding.description': 'Course description (max 2000 characters)',
    'tutorial.form.onboarding.level': 'Knowledge level',
    'tutorial.form.onboarding.participants': 'Number of participants',
    'tutorial.form.onboarding.industries': 'Industry',
    'tutorial.form.onboarding.targetGroups': 'Target group',
    'tutorial.form.onboarding.totalHours': 'Total course time',
    'tutorial.form.onboarding.modulesCount': 'Number of steps',
    'tutorial.form.onboarding.lessonsPerModule': 'Sections per step',
    'tutorial.form.onboarding.lessonMinutes': 'Average section duration',
    'tutorial.form.onboarding.intensity': 'Intensity',
    'tutorial.form.onboarding.styles': 'Teaching style',
    'tutorial.form.onboarding.tone': 'Communication tone',
    'tutorial.form.onboarding.materials': 'AI should create',
    'tutorial.form.onboarding.aiAvatar': 'AI avatar',
    'tutorial.form.onboarding.slides': 'Generate slides',
    'tutorial.form.onboarding.narration': 'Generate narration',
    'tutorial.form.onboarding.quizVideo': 'Generate quiz video',
    'tutorial.form.onboarding.graphics': 'Generate graphics',
    'tutorial.form.onboarding.graphicsStyle': 'Graphics style',
    'tutorial.form.onboarding.theoryPracticeRatio': 'Theory ←→ Practice',
    'tutorial.form.onboarding.exercisesCount': 'Number of exercises',
    'tutorial.form.onboarding.caseStudiesCount': 'Number of case studies',
    'tutorial.form.onboarding.finalProject': 'Final project',
    'tutorial.form.onboarding.finalExam': 'Final exam',
    'tutorial.form.onboarding.certificate': 'Completion certificate',
    'tutorial.form.onboarding.passThreshold': 'Passing threshold',
    'tutorial.form.onboarding.numbered': 'Numbered certificate',
    'tutorial.form.onboarding.qrVerification': 'Certificate QR verification',
    'tutorial.form.onboarding.goals.knowledge': 'Gain knowledge',
    'tutorial.form.onboarding.goals.skills': 'Gain skills',
    'tutorial.form.onboarding.goals.certification': 'Certification',
    'tutorial.form.onboarding.goals.process_implementation': 'Process implementation',
    'tutorial.form.onboarding.goals.sales_increase': 'Sales increase',
    'tutorial.form.onboarding.goals.company_automation': 'Company automation',
    'tutorial.form.onboarding.goals.career_growth': 'Career growth',
    'tutorial.form.onboarding.goals.exam_preparation': 'Exam preparation',
    'tutorial.form.onboarding.levels.beginner': 'Beginner',
    'tutorial.form.onboarding.levels.intermediate': 'Intermediate',
    'tutorial.form.onboarding.levels.advanced': 'Advanced',
    'tutorial.form.onboarding.levels.expert': 'Expert',
    'tutorial.form.onboarding.industries.b2b': 'B2B',
    'tutorial.form.onboarding.industries.ecommerce': 'E-commerce',
    'tutorial.form.onboarding.industries.services': 'Services',
    'tutorial.form.onboarding.industries.production': 'Manufacturing',
    'tutorial.form.onboarding.industries.accounting': 'Accounting',
    'tutorial.form.onboarding.industries.it': 'IT',
    'tutorial.form.onboarding.industries.education': 'Education',
    'tutorial.form.onboarding.industries.real_estate': 'Real estate',
    'tutorial.form.onboarding.industries.medicine': 'Medicine',
    'tutorial.form.onboarding.industries.other': 'Other',
    'tutorial.form.onboarding.targetGroups.business_owners': 'Business owners',
    'tutorial.form.onboarding.targetGroups.ceo': 'CEOs',
    'tutorial.form.onboarding.targetGroups.managers': 'Managers',
    'tutorial.form.onboarding.targetGroups.sales': 'Salespeople',
    'tutorial.form.onboarding.targetGroups.hr': 'HR',
    'tutorial.form.onboarding.targetGroups.marketing': 'Marketing',
    'tutorial.form.onboarding.targetGroups.developers': 'Developers',
    'tutorial.form.onboarding.targetGroups.freelancers': 'Freelancers',
    'tutorial.form.onboarding.targetGroups.employees': 'Employees',
    'tutorial.form.onboarding.intensities.micro_learning': 'Micro-learning',
    'tutorial.form.onboarding.intensities.standard': 'Standard',
    'tutorial.form.onboarding.intensities.academy': 'Academy',
    'tutorial.form.onboarding.intensities.masterclass': 'Masterclass',
    'tutorial.form.onboarding.styles.expert': 'Expert',
    'tutorial.form.onboarding.styles.business': 'Business',
    'tutorial.form.onboarding.styles.formal': 'Formal',
    'tutorial.form.onboarding.styles.practical': 'Practical',
    'tutorial.form.onboarding.styles.coaching': 'Coaching',
    'tutorial.form.onboarding.styles.storytelling': 'Storytelling',
    'tutorial.form.onboarding.styles.mentoring': 'Mentoring',
    'tutorial.form.onboarding.styles.workshop': 'Workshop',
    'tutorial.form.onboarding.tones.professional': 'Professional',
    'tutorial.form.onboarding.tones.friendly': 'Friendly',
    'tutorial.form.onboarding.tones.dynamic': 'Dynamic',
    'tutorial.form.onboarding.tones.premium': 'Premium',
    'tutorial.form.onboarding.tones.corporate': 'Corporate',
    'tutorial.form.onboarding.materials.outline': 'Outline',
    'tutorial.form.onboarding.materials.full_lessons': 'Full lesson content',
    'tutorial.form.onboarding.materials.presentations': 'Presentations',
    'tutorial.form.onboarding.materials.pdf': 'PDF',
    'tutorial.form.onboarding.materials.workbook': 'Workbook',
    'tutorial.form.onboarding.materials.checklists': 'Checklists',
    'tutorial.form.onboarding.materials.quizzes': 'Quizzes',
    'tutorial.form.onboarding.materials.exams': 'Exams',
    'tutorial.form.onboarding.materials.certificate': 'Certificate',
    'tutorial.form.onboarding.materials.practical_tasks': 'Practical tasks',
    'tutorial.form.onboarding.materials.worksheets': 'Worksheets',
    'tutorial.form.onboarding.materials.prompt_pack': 'Prompt Pack',
    'tutorial.form.onboarding.materials.case_study': 'Case study',
    'tutorial.form.onboarding.materials.landing_page': 'Landing page',
    'tutorial.form.onboarding.materials.sales_webinar': 'Sales webinar',
    'tutorial.form.onboarding.materials.email_campaign': 'E-mail campaign',
    'tutorial.form.onboarding.materials.social_posts': 'Social media posts',
    'tutorial.form.onboarding.materials.meta_ads': 'Meta ads',
    'tutorial.form.onboarding.materials.google_ads': 'Google ads',
    'tutorial.form.onboarding.imageStyles.photorealistic': 'Photorealistic',
    'tutorial.form.onboarding.imageStyles.corporate': 'Corporate',
    'tutorial.form.onboarding.imageStyles.minimalist': 'Minimalist',
    'tutorial.form.onboarding.imageStyles.3d': '3D',
    'tutorial.form.onboarding.imageStyles.infographic': 'Infographics',
    'tutorial.form.onboarding.imageStyles.comic': 'Comic',
    'tutorial.form.onboarding.imageStyles.premium': 'Premium',
    'tutorial.form.sourcePreview': 'Source preview',
    'tutorial.form.editor.addField': 'Add field',
    'tutorial.form.editor.addOption': 'Add option',
    'tutorial.form.editor.fieldType': 'Field type',
    'tutorial.form.editor.label': 'Label',
    'tutorial.form.editor.max': 'Max',
    'tutorial.form.editor.min': 'Min',
    'tutorial.form.editor.moveDown': 'Move down',
    'tutorial.form.editor.moveUp': 'Move up',
    'tutorial.form.editor.multiple': 'Multiple',
    'tutorial.form.editor.name': 'Name',
    'tutorial.form.editor.optionLabel': 'Option label',
    'tutorial.form.editor.optionValue': 'Option value',
    'tutorial.form.editor.options': 'Options',
    'tutorial.form.editor.placeholder': 'Placeholder',
    'tutorial.form.editor.remove': 'Remove',
    'tutorial.form.editor.required': 'Required',
    'tutorial.form.editor.rows': 'Rows',
    'tutorial.form.editor.showValue': 'Show value',
    'tutorial.form.editor.step': 'Step',
    'tutorial.form.editor.submitLabel': 'Submit button label',
    'tutorial.form.editor.type': 'Type',
    'tutorial.form.editor.unit': 'Unit',
    'tutorial.form.editor.fieldType.input': 'Text input',
    'tutorial.form.editor.fieldType.textarea': 'Text area',
    'tutorial.form.editor.fieldType.select': 'Dropdown',
    'tutorial.form.editor.fieldType.radio': 'Radio buttons',
    'tutorial.form.editor.fieldType.checkbox': 'Checkbox',
    'tutorial.form.editor.fieldType.date': 'Date',
    'tutorial.form.editor.fieldType.switch': 'Switch',
    'tutorial.form.editor.fieldType.slider': 'Slider',
    'tutorial.form.editor.inputFieldType.text': 'Text',
    'tutorial.form.editor.inputFieldType.number': 'Number',
    'tutorial.form.editor.inputFieldType.email': 'Email',
    'tutorial.form.editor.inputFieldType.password': 'Password',
    'tutorial.form.editor.inputFieldType.tel': 'Phone',
    'tutorial.form.editor.inputFieldType.url': 'URL',
    'tutorial.form.editor.inputFieldType.search': 'Search',
    'tutorial.form.editor.inputFieldType.date': 'Date',
    'tutorial.form.editor.inputFieldType.datetime-local': 'Date and time',
    'tutorial.form.editor.inputFieldType.time': 'Time',
    'tutorial.form.editor.defaultSubmitLabel': 'Submit',
    'tutorial.form.editor.defaultFieldLabel': 'New field',
    'tutorial.form.editor.defaultOptionLabel': 'Option {index}',
    'tutorial.form.editor.formEditor': 'Form editor',
    'tutorial.form.editor.formIncluded': 'Form added',
    'tutorial.form.editor.saveForm': 'Save form',
};
